import $ from 'jquery';
import {getWidth} from "../utils/window";

export default function headerSection() {
	const $html = $('html');
	const $scroller = $('html, body');

	const $header = $('#header');
	const $headerNav = $('#header-nav');
	const headerToggler = $headerNav.data('toggler');

	if (headerToggler) {

		headerToggler.on('toggle', function() {
			$html.toggleClass('is-header-open', headerToggler.isOpen);

			if (headerToggler.isOpen) {
				$scroller.animate({ scrollTop: 0 }, { duration: 200 });
			}
		});
	}

	$(function(){
		let nav = $headerNav.find('.-level-2.-has-children');
		let navAnchors = $headerNav.find('.-parent > a');

		if (nav.length) {
			nav.parent().addClass('-has-three-levels');
		}

		if (navAnchors.length) {
			navAnchors.click(function (e) {
				e.preventDefault();

				let _this = $(this);

				if (getWidth() <= 1080) {
					_this.toggleClass('is-selected');
					_this.next().slideToggle(400);
				}
			});
		}

		$('[href="//"]').click(function(e){
			e.preventDefault();
		});
	});
}



// WEBPACK FOOTER //
// ./source/scripts/sections/header.js